<template>
    <order-timeline-box
            :title="__('general.handed_over')"
            :message="logsByState.hasOwnProperty(OrderState.PickedUp) ? users[logsByState[OrderState.PickedUp].issuer_uid] : ''"
            :timestamp="logsByState.hasOwnProperty(OrderState.PickedUp) ? logsByState[OrderState.PickedUp].created_at : ''"
            :complete="isComplete"
            :spinner="isLoading"
            icon="fa-check-circle"
    >
        <button class="btn btn-success" @click="transitionToCollected" :disabled="isLoading">
            <i class="fas fa-people-arrows"/>
            {{ __('actions.order.transition_to.collected') }}
        </button>
    </order-timeline-box>
</template>

<script>
import OrderTimelineBox from '@components/Orders/Timeline/OrderTimelineBox.vue';
import {OrderState} from '@composables/orderStates';

export default {
    components: {OrderTimelineBox},

    props: {
        store: Object,
        order: Object,
        users: Object,
    },

    methods: {
        transitionToCollected() {
            let vue = this;
            if (this.order.is_paid) {
                this.$emit('transition', OrderState.PickedUp);
            } else {
                Swal.fire({
                    title: __('orders.unpaid'),
                    text: __('orders.payment.received_question'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success m-0',
                    confirmButtonText: this.__('general.yes'),
                    cancelButtonText: this.__('actions.abort'),
                }).then((result) => {
                    if (result.value) {
                        vue.$inertia.visit(this.$route('order.payment', [this.store.id, this.order.url_key]), {
                            data: {
                                state: 'paid',
                            },
                            method: 'PATCH',
                            onSuccess() {
                                vue.$emit('transition', OrderState.PickedUp);
                            },
                        });
                    }
                });
            }
        },
    },

    computed: {
        OrderState() {
            return OrderState;
        },

        logsByState(){
            return this.order.logs_by_state;
        },

        isComplete() {
            return this.logsByState.hasOwnProperty(OrderState.PickedUp)
                || this.logsByState.hasOwnProperty(OrderState.Cancelled)
                || this.logsByState.hasOwnProperty(OrderState.Rejected)
                || this.logsByState.hasOwnProperty(OrderState.Refunded);
        },

        isLoading() {
            return !this.isComplete && this.order.state === OrderState.WaitForIntegration;
        },
    },
};
</script>
